export enum ContactNumberType {
    PHONENUMBER = 'PHONENUMBER',
    MOBILENUMBER = 'MOBILENUMBER',
    FAXNUMBER = 'FAXNUMBER',
}
